import { assign, createMachine } from 'xstate';
import { updateCustomFields } from '@chargify/custom-fields';
import { Context } from './types';

export const createCustomFieldsMachine = (subscriptionId: number) =>
  createMachine<Context>({
    id: 'customFields',
    predictableActionArguments: true,
    context: {
      subscriptionId,
      customFields: null,
    },
    initial: 'idle',
    states: {
      idle: {
        on: {
          INITIALIZE: {
            target: 'loading',
          },
        },
      },
      loading: {
        invoke: {
          src: 'getSubscriptionCustomFields',
          onDone: {
            target: 'ready',
            actions: assign((_ctx, event) => {
              return {
                customFields: event.data.items,
              };
            }),
          },
          onError: {
            target: 'error',
          },
        },
      },
      ready: {
        on: {
          EDIT_CUSTOM_FIELDS: {
            target: 'customFieldsEdit',
          },
        },
      },
      error: {
        on: {
          INITIALIZE: {
            target: 'loading',
          },
        },
      },
      customFieldsEdit: {
        id: 'customFieldsEdit',
        initial: 'idle',
        states: {
          idle: {
            on: {
              SAVE: {
                target: 'saving',
              },
              CANCEL: {
                target: '#customFields',
              },
            },
          },
          saving: {
            invoke: {
              src: 'saveCustomerCustomFields',
              onDone: {
                target: '#customFields.ready',
                actions: assign((ctx, event) => {
                  return {
                    customFields: updateCustomFields(
                      ctx.customFields,
                      event.data.fields
                    ),
                  };
                }),
              },
              onError: {
                target: 'error',
              },
            },
          },
          error: {
            on: {
              CANCEL: {
                target: '#customFields',
              },
              SAVE: {
                target: 'saving',
              },
            },
          },
        },
      },
    },
  });
